<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="10">
                <el-form-item label="时间范围：" class="search-item" :label-width="labelWidth">
                  <el-date-picker
                      v-model="period" type="daterange" align="right"
                      unlink-panels range-separator="-"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="timePickerOptions"
                      @change="onDateChange()"  />
                  &nbsp;
                  <el-tooltip content="上个自然月" placement="top">
                    <el-button type="primary" icon="el-icon-arrow-left" plain
                               @click="handleLastMonth" circle  />
                  </el-tooltip>
                  <el-tooltip content="本月" placement="top">
                    <el-button type="primary" icon="el-icon-refresh-right" plain
                               @click="initDate" circle />
                  </el-tooltip>
                  <el-tooltip content="下个自然月" placement="top">
                    <el-button type="primary" icon="el-icon-arrow-right" plain
                               @click="handleNextMonth" circle  />
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户：" prop="user" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.user" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" align="center" width="75px" />
          <el-table-column prop="namespace" label="用户" width="160px" />
          <el-table-column prop="cost" label="计费（元）" align="right" width="120px"
              :formatter="formatCost"/>
          <el-table-column header-align="center" align="center" show-overflow-tooltip width="150" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="showDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "集群用户用量计费",
      labelWidth: '120px',
      tableDataApi: '/api/ns-cost',

      searchForm: {
        user:'',
        gpuModel: '',
        from: '',
        to: '',
      },
      period: [],
      currentRow: {},
    }
  },
  computed: {
  },
  mounted () {
    this.initDate()
    this.loadParams()
    this.updateDatePicker()
  },
  methods: {
    loadParams () {
      console.log('+++ user-cost +++', this.$route.query)
      if('from' in this.$route.query && this.$route.query.from) {
        let day = new Date(this.$route.query.from)
        this.searchForm.from = this.getDateStr(day, '00:00:00');
      }
      if('to' in this.$route.query && this.$route.query.to) {
        let day = new Date(this.$route.query.to)
        this.searchForm.to = this.getDateStr(day, '23:59:59');
      }
      if('namespace' in this.$route.query && this.$route.query.namespace) {
        this.searchForm.namespace = this.$route.query.namespace
      }
      if('page' in this.$route.query && this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10)
        this.pagination.currentPage = this.pagination.page
      }
      if('pageSize' in this.$route.query && this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize,10)
      }
      if('total' in this.$route.query && this.$route.query.total) {
          this.pagination.total = parseInt(this.$route.query.total, 10)
      }
      this.handleCurrentChange(this.pagination.page)
    },
    handleReset () {
      this.searchForm = {
        gpuModel: '',
        from: '',
        to: '',
      }
      this.initDate()
      this.getTableData()
      this.updateDatePicker()
    },
    handleSearch () {
      this.getTableData()
      this.updateDatePicker()
    },

    formatCost (value) {
      return parseFloat(value.cost).toFixed(2)
    },

    showDetail (row) {
      this.$router.push({
        path: 'pod-usage',
        query: {
          namespace: row.namespace,
          from: this.searchForm.from,
          to: this.searchForm.to,
          orgNamespace: this.searchForm.namespace,
          orgFrom: this.searchForm.from,
          orgTo: this.searchForm.to,
          orgPage: this.pagination.page,
          orgPageSize: this.pagination.pageSize,
          orgTotal: this.pagination.total, 
        }
      })
    },

    //////////////////////////////////////////////
    /////////////// BEGIN - 时间段处理
    // 日期字符串处理
    getDateStr(d, time) {
      var str = d.getFullYear();
      str += "-";
      var MM = d.getMonth()+1;
      if(MM<10) str += '0' + MM;
      else str += MM;
      str += "-";
      var dd = d.getDate();
      if(dd<10) str += '0' + dd;
      else str += dd;
      if(time.length<1) str += " 00:00:00";
      else str += " " + time;
      return str;
    },
    // 回显到el-date-picker
    updateDatePicker() {
      this.$nextTick(() => {
        this.period = [this.searchForm.from, this.searchForm.to];
      })
    },
    initDate() {
      let day = new Date();
      day.setMonth(day.getMonth(), 1);
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth()+1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker();

      this.getTableData();     // 请求数据
    },
    onDateChange() {
      if(this.period==null || this.period[0]==null) {
        this.initDate();
      }
      let from = new Date(this.period[0]);
      let to = new Date(this.period[1]);
      this.searchForm.from = this.getDateStr(from, '00:00:00');
      this.searchForm.to = this.getDateStr(to, '23:59:59');
      this.updateDatePicker();
    },
    handleLastMonth () {
      if(this.period==null || this.period[0]==null) {
        this.initDate()
      }
      let day = new Date(this.searchForm.from)
      day.setMonth(day.getMonth() - 1, 1)
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth()+1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker()

      this.getTableData();     // 请求数据
    },
    handleNextMonth () {
      if(this.period==null || this.period[0]==null) {
        this.initDate()
      }
      let day = new Date(this.searchForm.from)
      day.setMonth(day.getMonth() + 1, 1)
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth() + 1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker()
      this.getTableData();     // 请求数据
    },
    /////////////// END - 时间段处理
    //////////////////////////////////////////////
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
